module.exports = __webpack_public_path__ + "img/Feature-1.8c44895.svg";